export const LS2KIDS_CONSTANTS = {
	GoogleAnalytics: {
		configDimensionName: 'dimension1',
		configConvertedName: 'PACConfig'
	},
	targetAudience:  'abcj',

	searchDatabases: {
		ls2pac:   'ls2pac',
		category: 'category',
		series:   'series'
	},

	Urls:       {
		__start: '/categories', // if we enter the site, where do we go first

		home:                 '/',
		categories:           '/categories',
		series:               '/series',
		search:               '/search',
		categorySearch:       '/categorySearch',
		seriesSearch:         '/seriesSearch',
		fullDetails:          '/fullDetails',
		getSearchSuggestions: '/search/searchSuggestions',
		login:                '/login',
		error:                '/error'
	},
	CssClasses: {},
	restUrls:   {
		category: {
			/**
			 * Gets the on image url for a category, based off its id.
			 *
			 * @param {number} id the id number of the category
			 * @return {string} the url of where the icon
			 */
			onImage: function ( id ) {
				return '/category/icon/' + id + '/on';
			},


			/**
			 * Gets the on image url for a category, based off its id.
			 *
			 * @param {number} id the id number of the category
			 * @return {string} the url of where the icon
			 */
			offImage: function ( id ) {
				return '/category/icon/' + id + '/off';
			}
		},
		fullDetails:    'resource/kids/details/',
		search:         'search',
		categories:     'category',
		series:         'series',
		_seriesIcons:   'gridIcons',
		categorySearch: 'category/resources',
		seriesSearch:   'series/resources'
	},

	Ids: {
		app:         'app-main',
		mainHeader:  'mainHeader',
		activeTheme: 'ls2kids-active-theme',
		header:      {
			searchForm:          'header_searchForm',
			searchInput:         'header_searchInput',
			header_clearSearch:  'header_clearSearch',
			headerLoginLink:     'headerLoginLink',
			adfsHeaderLoginLink: 'adfsHeaderLoginLink'
		},
		SearchPage:  {
			searchResultsAreaContainer: 'searchResultsAreaContainer',
			searchResultsContainer:     'searchResultsContainer',
			searchErrorContainer:       'searchErrorContainer',
			resultsScrollWrapper:       'resultsScrollWrapper',
			searchTerm:                 'searchTerm',
			currentPage:                'currentPage',
			resultsList:                'resultsList',
			totalPages:                 'totalPages',
			bookJacketSuffix:           '_bookJacket',
			totalResults:               'totalResults',
			searchResultTitle:          'searchResultTitle'
		},
		FullDetails: {
			tabContentWrapper:      'tabContentWrapper',
			tabPanelWrapper:        'details_tabPanelWrapper',
			tabContentWrapperInner: 'tabContentWrapperInner',
			fullDetailsContainer:   'fullDetailsContainer',

			mainJacket: 'detailsPage_mainJacket',
			teachingBooksLink: 'detailsPage_teachingBooksLink',
			teachingBooksForm: 'detailsPage_teachingBooksForm',
			tabber:     'detailsPage_tabber',

			detailsTab:      'detailsPage_detailsTab',
			summaryTab:      'detailsPage_summaryTab',
			readingLevelTab: 'detailsPage_readingLevelTab',
			copiesTab:       'detailsPage_copiesTab',

			copiesContainer:       'detailsPage_copiesContainer',
			detailsContainer:      'detailsPage_detailsContainer',
			readingLevelContainer: 'detailsPage_readingLevelContainer',
			summaryContainer:      'detailsPage_summaryContainer',

			copiesTabContent: 'detailsPage_copiesContent',
			amazonContent:    'detailsPage_amazon'
		},

		login: {
			loginView: 'loginView'
		},

		footer: {
			mainFooter:        'mainFooter',
			currentSearchIcon: 'currentSearchIcon',
			exploreCategories: 'exploreCategories',
			exploreSeries:     'exploreSeries'
		},

		mainFooter:   'mainFooter',
		mainContent:  'mainContent',
		progressBar:  'progressBar',
		mainLoader:   'mainLoader',
		categoryPage: {
			main:                  'mainCategory',
			categoryList:          'categoryList',
			categoryScrollWrapper: 'categoryScrollWrapper'
		},
		seriesPage:   {
			main:                'mainSeries',
			seriesList:          'seriesList',
			seriesScrollWrapper: 'seriesScrollWrapper'
		},
		gridPage:     {
			main: 'mainGrid'
		},
		Messaging:    {
			main:      'app-messaging',
			container: 'messagingContainer'
		}
	},

	Events: {
		onSearch:                'search',
		onStartCategoryView:     'onStartCategoryView',
		onCategoryViewStarted:   'onCategoryViewStarted',
		onStartSeriesView:       'onStartSeriesView',
		onSeriesViewStarted:     'onSeriesViewStarted',
		onStartResultsView:      'onStartResultsView',
		onShowFullDetails:       'onShowFullDetails',
		onGetSearchSuggestions:  'onGetSearchSuggestions',
		onGetCategories:         'onGetCategories',
		onGetCategoriesResponse: 'onGetCategoriesResponse',
		onGetSeries:             'onGetSeries',
		onGetSeriesResponse:     'onGetSeriesResponse',
		onGetGridIcons:          'onGetGridIcons',
		onGetGridIconsResponse:  'onGetGridIconsResponse',
		onPageChanged:           'onPageChanged',
		onShowLoadingMessage:    'onShowLoadingMessage',
		onGridRefresh:           'onGridRefresh',
		onCategoryGridRefresh:   'onCategoryGridRefresh',
		onSeriesGridRefresh:     'onSeriesGridRefresh',
		onHoldResource:          'onHoldResource',
		onPromptToHoldResource:  'onPromptToHoldResource',
		onShowLogin:             'onShowLogin',
		onShowCurrentSearchIcon: 'onShowCurrentSearchIcon',
		onHideCurrentSearchIcon: 'onHideCurrentSearchIcon',
		onStartAutoCycle:        'onStartAutoCycle',
		onShowError:             'onShowError',

		onGridViewPrevPage:  'onGridViewPrevPage',
		onGridViewNextPage:  'onGridViewNextPage',
		onSearchGridRefresh: 'onSearchGridRefresh',

		onFocusFullDetailsSection: 'onFocusFullDetailsSection',

		onResultsViewPrevPage: "onResultsViewPrevPage",
		onResultsViewNextPage: "onResultsViewNextPage",

		getSearchSuggestions:         "getSearchSuggestions",
		getSearchSuggestionsResponse: "getSearchSuggestionsResponse"
	},

	seriesAspectRatio:     ( 16 / 9.05 ),
	curatedContentServers: [
		"ls2curatedcontent.tlcdelivers.com"
		//		"ls2curatedcontenttest.tlcdelivers.com:8090"
		//		"ls2curatedcontent2.tlcdelivers.com",
		//		"ls2curatedcontent3.tlcdelivers.com",
		//		"ls2curatedcontent4.tlcdelivers.com"
	]
};
